import { render, staticRenderFns } from "./FieldStarRating.vue?vue&type=template&id=54875300&scoped=true&"
import script from "./FieldStarRating.vue?vue&type=script&lang=js&"
export * from "./FieldStarRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54875300",
  null
  
)

export default component.exports